import Pagination from '@api/entities/Pagination';
class BricksSold {
    list;
    pagination;
    constructor(data) {
        this.list = data.soldBricks;
        this.pagination = new Pagination({
            /**
             * TODO: This hardcoded values are expecting to be replaced in a new endpoint version,
             * the current one works with pagination but only returns total
             * */
            pagination: {
                totalPages: 0,
                perPage: 10,
                page: 1
            },
            count: data.total
        });
    }
}
export default BricksSold;
